import React from "react";
import { Redirect, RouteComponentProps } from "react-router-dom";
import { useUserId } from "../../../../query/hooks/helpers";
import { useQueryWorkLog } from "../../../../query/workLog/queries/useQueryWorkLog";
import {
  getPathWorkLogPayeeDetails,
  getPathWorkLogPayerDetails,
  PATH_WORK_LOGS
} from "../../paths";

export const RouteWorkLogRedirect: React.FC<
  RouteComponentProps<{ workLogId: string }>
> = props => {
  const { workLogId } = props.match.params;
  const userId = useUserId();
  const queryWorkLog = useQueryWorkLog(workLogId);

  if (queryWorkLog.isLoading) {
    return null;
  }

  const workLog = queryWorkLog.data;

  if (workLog?.payerId === userId) {
    return <Redirect to={getPathWorkLogPayerDetails(workLogId)} />;
  }

  if (workLog?.payeeId === userId) {
    return <Redirect to={getPathWorkLogPayeeDetails(workLogId)} />;
  }

  return <Redirect to={PATH_WORK_LOGS} />;
};
